import React, { useState } from 'react';

import { useFilter } from '../hooks/useFilter';
import useAutomationList from '../hooks/useAutomationList';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import { AutomationRuleConflictMessage } from '../WorkflowBuilder/components';
import Header from './Header';
import Filter from './Filter';
import Table from './Table';
import RunAutomationModal from './RunAutomationModal';

export default function AutomationList() {
  const { filter, refreshList, filterOnChange, filterDebounced } = useFilter();
  const {
    automationList,
    paginatorTemplate,
    pageSize,
    handleDuplicateAutomationRule,
    conflictErrorData,
    setConflictErrorData,
    updateStatus,
  } = useAutomationList(10, filterDebounced);

  const [runModalVisible, setRunModalVisible] = useState(false);
  const [selectedAutomationData, setSelectedAutomationData] = useState(null);

  const handleRunAutomation = (automationData) => {
    setSelectedAutomationData(automationData);
    setRunModalVisible(true);
  };

  const handleCloseRunModal = () => {
    setRunModalVisible(false);
    setSelectedAutomationData(null);
  };
  return (
    <div className="container-fluid px-0">
      <GlobalLoader />
      <Header />
      <div className="d-flex flex-wrap align-items-center mb-3 p-1">
        <Filter {...{ filter, refreshList, filterOnChange }} />
      </div>
      <div className="datatable-wrapper">
        <Table {...{ automationList, pageSize, paginatorTemplate, handleDuplicateAutomationRule, updateStatus, handleRunAutomation }} />
      </div>
      {conflictErrorData && (
        <AutomationRuleConflictMessage ruleValidationErrorData={conflictErrorData} onHide={() => setConflictErrorData(null)} />
      )}
      <RunAutomationModal visible={runModalVisible} onHide={handleCloseRunModal} automationData={selectedAutomationData} />
    </div>
  );
}
